<template>
  <div class="guider-apply-container">
    <div class="pc">
      <hm-content title :hidden="hidden">
        <div class>
          <el-radio-group
            v-model="auditState"
            size="small"
            @change="switchTabs"
          >
            <el-radio-button label="all"
              >全部({{ auditCount.allCount }})</el-radio-button
            >
            <el-radio-button label="wait"
              >待审核({{ auditCount.waitCount }})</el-radio-button
            >
            <el-radio-button label="agree"
              >同意({{ auditCount.agreeCount }})</el-radio-button
            >
            <el-radio-button label="refuse"
              >拒绝({{ auditCount.refuseCount }})</el-radio-button
            >
          </el-radio-group>
          <div class="table-panel flex flex-end flex-wrap mb20 mt20">
            <el-select
              clearable
              size="small"
              class="mr10"
              filterable
              v-model="searchCondition.brandId"
              placeholder="请选择品牌"
            >
              <el-option
                :label="v.brandName"
                :value="v.hemiaoBrandId"
                v-for="(v, i) in hemiaoBrandBoxList"
                :key="i"
              ></el-option>
            </el-select>
            <el-date-picker
              :default-time="['00:00:00', '23:59:59']"
              v-model="searchCondition.applyDate"
              type="datetimerange"
              align="right"
              start-placeholder="加入开始日期"
              end-placeholder="加入结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
            ></el-date-picker>
            <el-input
              clearable
              v-model.trim="searchCondition.keyWorks"
              placeholder="请输入门店名称/导购名称/电话号码"
              size="small"
              style="width: 222px"
              class="ipt mr10"
            ></el-input>
            <el-button type="primary" size="small" @click="search"
              >查询</el-button
            >
            <el-button type="success" size="small" @click="outputDetail"
              >生成报表</el-button
            >
          </div>
          <div class="table">
            <el-table
              stripe
              border
              ref="brandTable"
              @selection-change="getChecked"
              :data="supplierBrandGuiderList.records"
              style="width: 100%"
              id="table"
              size="small"
            >
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                :index="index => index + (currentPage - 1) * pageSize + 1"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="申请状态"
              >
                <template slot-scope="scope">
                  <span class="success" v-if="scope.row.auditState === 'agree'"
                    >同意</span
                  >
                  <span class="danger" v-if="scope.row.auditState === 'refuse'"
                    >拒绝</span
                  >
                  <span class="blue" v-if="scope.row.auditState === 'wait'"
                    >待审核</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="idcardNo"
                label="身份证号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="guiderPhone"
                label="电话号码"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="provinceName"
                label="所在省/市/区"
              >
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.provinceName }}{{ scope.row.cityName
                    }}{{ scope.row.districtName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="storeName"
                label="所属商户"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="shopName"
                label="所属门店"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="createTime"
                label="申请时间"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="brandName"
                label="申请商品品牌"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="auditUsername"
                label="审核人"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="auditTime"
                label="审核时间"
              ></el-table-column>
              <!-- 已审核已驳回不显示 -->
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="操作"
                width="180"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-button
                      size="small"
                      type="text"
                      @click="viewDetails(scope.row)"
                      >导购信息</el-button
                    >
                    <el-button
                      size="small"
                      type="text"
                      @click="audit(scope.row)"
                      v-if="scope.row.auditState === 'wait'"
                      >同意</el-button
                    >
                    <el-button
                      size="small"
                      type="text"
                      @click="reject(scope.row)"
                      v-if="scope.row.auditState === 'wait'"
                      >拒绝</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="hm-pagination">
              <el-pagination
                background
                :total="supplierBrandGuiderList.total"
                @current-change="paging"
                @size-change="handleSizeChange"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="currentPage"
              ></el-pagination>
            </div>
          </div>
        </div>
        <el-dialog
          title="导购信息"
          :close-on-click-modal="false"
          :visible.sync="detailsDialogVisible"
          custom-class="sales-volumn-dialog"
        >
          <el-table
            stripe
            border
            ref="brandTable"
            class="mb20"
            :data="[detailsGuiderInfo.guiderInfo]"
            style="width: 100%"
            id="table"
            size="small"
          >
            <el-table-column
              header-align="center"
              align="center"
              prop="guiderName"
              label="导购姓名"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="guiderPhone"
              label="电话"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="idcardNo"
              label="身份证号"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="storeName"
              label="所属商户"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="shopName"
              label="所属门店"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="shopAddress"
              label="门店地址"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.provinceName }}{{ scope.row.cityName
                  }}{{ scope.row.districtName }}{{ scope.row.shopAddress }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="supplierName"
              label="已加入渠道商"
            ></el-table-column>
          </el-table>
          <div class="flex mb20">
            <!-- <el-table
              stripe
              border
              ref="brandTable"
              class="mb20"
              :data="detailsGuiderInfo.brandGuiderRelList"
              style="width: 100%"
              id="table"
              size="small"
            >
              <el-table-column
                header-align="center"
                align="center"
                prop="brandName"
                label="已加入品牌"
              ></el-table-column>
            </el-table> -->
            <div class="title mr10">已加入品牌:</div>
            <div
              class="blue"
              v-for="(v, i) in detailsGuiderInfo.brandGuiderRelList"
              :key="i"
            >
              {{ i === 0 ? "" : "," }}{{ v.brandName }}
            </div>
          </div>
          <div class="flex mb20">
            <div class="title mr10">工牌照片</div>
            <div>
              <el-image
                style="width: 200px; height: 200px"
                class="mr10"
                :src="detailsGuiderInfo.guiderInfo.workCardImg"
                :preview-src-list="[detailsGuiderInfo.guiderInfo.workCardImg]"
              ></el-image>
            </div>
          </div>
          <div class="flex">
            <div class="title mr10">门店门头照片</div>
            <div>
              <el-image
                style="width: 200px; height: 200px"
                class="mr10"
                :src="detailsGuiderInfo.guiderInfo.outletImg"
                :preview-src-list="[detailsGuiderInfo.guiderInfo.outletImg]"
              ></el-image>
            </div>
          </div>
        </el-dialog>
        <!-- <el-dialog
          title="驳回备注"
          :close-on-click-modal="false"
          :visible.sync="dialogVisible"
          custom-class="sales-volumn-dialog"
        >
          <el-form label-width="80px">
            <el-form-item label="驳回原因">
              <el-input
                maxlength="100"
                placeholder="请输入驳回原因，可直接选择下方模板"
                size="small"
                style="width: auto"
                :autosize="{ minRows: 4 }"
                type="textarea"
                v-model="reason"
              ></el-input>
            </el-form-item>
            <div class="reject-reason">
              <el-radio-group
                v-model="rejectReason"
                @change="switchRejectReason"
              >
                <div v-for="(v, i) in rejectTemp" :key="i">
                  <el-radio :label="i">{{ v }}</el-radio>
                </div>
              </el-radio-group>
            </div>
          </el-form>
          <span slot="footer" class="dialog-footer flex flex-center">
            <el-button @click="submitRuleForm" size="small" type="primary"
              >保存</el-button
            >
            <el-button @click="dialogVisible = false" size="small"
              >关闭</el-button
            >
          </span>
        </el-dialog> -->
      </hm-content>
    </div>
    <!-- <div class="mobile">
      <div class="tabs flex flex-between">
        <div
          @click="switchTab(i)"
          class="tab"
          :class="{ active: activeTab === i }"
          v-for="(v, i) in tabList"
          :key="i"
        >
          {{ v.name }}
        </div>
      </div>
      <div class="scroll-content">
        <div class="control-panel flex">
          <div class="ipt-wrapper flex-1 flex item-center">
            <span class="icon hmicon icon-search"></span>
            <form @submit="search">
              <input
                type="search"
                ref="ipt"
                class="flex-1"
                placeholder="请输入导购名称/电话"
                v-model="keywords"
              />
            </form>
          </div>
          <el-date-picker
            v-model="searchCondition.date"
            type="daterange"
            align="right"
            start-placeholder="申报开始时间"
            end-placeholder="申报结束时间"
            value-format="yyyy-MM-dd"
            size="small"
            class="mr10"
          ></el-date-picker>
        </div>
        <ul class="list">
          <li
            v-infinite-scroll="load"
            class="list-item"
            @click="toDetails(v)"
            v-for="(v, i) in mobileList"
            :key="i"
          >
            <div class="flex flex-between item-center">
              <div class="flex item-center">
                <div class="tag">导购信息</div>
                <div class="user-info flex-1">
                  <span class="mr10">{{ v.guideName }}</span>
                  <span>{{ v.mobile }}</span>
                </div>
              </div>
            </div>
            <div class="info">
              <div>
                加入渠道商：
                <span class="merchant">{{ v.merchant }}</span>
              </div>
              <div>
                <span class="date gray">申报日期：{{ v.date }}</span>
              </div>
            </div>
          </li>
        </ul>
        <p v-if="loading">加载中...</p>
        <p v-if="noMore">没有更多了</p>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapMutations  } from "vuex";
import { arrayUnique2, setCookie, getCookie } from "@/utils/utils";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      hidden: true,
      city: "",
      status: "",
      detailsDialogVisible: false,
      storeList: [
        {
          city: "武汉市"
        }
      ],
      auditState: "wait",
      srcList: [
        "https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg",
        "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg"
      ],
      rejectReason: "",
      reason: "",
      dialogVisible: false,
      isOutputing: false,
      searchCondition: {},
      currentPage: 1,
      pageSize: 10,
      rejectTemp: [],
      tabPosition: "all",
      activeTab: 0,
      // 移动端data
      keywords: "",
      tabList: [
        {
          name: "待审核"
        },
        {
          name: "已审核"
        },
        {
          name: "已驳回"
        }
      ],
      loading: false,
      noMore: false,
      mobileList: [
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华"
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华"
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华"
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华"
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华"
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华"
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华"
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华"
        },
        {
          price: 109,
          guideName: "唐小鸭",
          mobile: "13838380741",
          date: "2019-08-09 12:00:05",
          merchant: "武汉兴明华"
        }
      ],
      hemiaoBrandBoxList: [],
      auditCount:{}
    };
  },
  computed: mapGetters([
    "supplierBrandGuiderList",
    "detailsGuiderInfo",
    // "auditCount"
  ]),
  watch: {},
  created() {
    // this.queryList();
    this.queryBrandList();
    // this.$store.dispatch("auditRelStateCount");
    this.getCookie();
    this.QUERY_SUPPLIER_BRAND_GUIDER_LIST({
      result:{
         records:[],
          total: 0
      }
    });
  },
  methods: {
     ...mapMutations (["QUERY_SUPPLIER_BRAND_GUIDER_LIST"]),
      getCookie() {
      const countAll = getCookie({
        key: "auditCountAll",
        type: "session",
      });
      console.log("auditCount:", countAll);
      if (countAll && countAll.cookieTime === moment().format("YYYY-MM-DD")) {
        this.auditCount = countAll.result;
      } else {
        this.queryGuiderAuditCountAll();
      }
    },
    async queryGuiderAuditCountAll() {
      let params = {};
      const { result } = await this.$store.dispatch(
        "auditRelStateCount",
        params
      );
      console.log("auditRelStateCount:", result);
      this.auditCount = result;
      let cookieTime = moment().format("YYYY-MM-DD");
      setCookie({
        key: "auditCountAll",
        type: "session",
        data: {
          cookieTime: cookieTime,
          result: this.auditCount,
        },
      });
    },
    async queryBrandList() {
      const { result } = await this.$store.dispatch("queryHemiaoBrandComboBox");
      this.hemiaoBrandBoxList = result;
    },
    switchTabs() {
      this.queryList();
    },
    viewDetails(row) {
      this.detailsDialogVisible = true;
      this.$store.dispatch("detailsGuiderInfo", {
        guiderId: row.guiderId
      });
    },
    switchRejectReason() {
      this.reason = this.rejectTemp[this.rejectReason];
    },

    async reject(row) {
      const result = await this.$confirm(`是否拒绝？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        this.auditGuiderInfos(row.relId, "refuse");
      }
    },
    output() {},
    search() {
      this.queryList();
    },
    outputDetail() {
      let params = {
        auditState: this.auditState === "all" ? "" : this.auditState
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.startTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      Object.assign(params, searchCondition);
      this.$store.dispatch("exoprtGuiderBrandDeclareList", params);
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success"
        });
        this.hidden = false;
      }, 0);
    },
    queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        auditState: this.auditState === "all" ? "" : this.auditState
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.startTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.endTime =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
        if (
        !searchCondition.brandId &&
        !searchCondition.startTime &&
        !searchCondition.endTime &&
        !searchCondition.keyWorks
      ) {
        this.$message({
          type: "warning",
          message: "请先选择查询条件",
        });
        return false;
      }   
      Object.assign(params, searchCondition);
      return this.$store.dispatch("querySupplierBrandGuiderList", params);
    },
    async auditGuiderInfos(relId, auditState) {
      let params = {
        relId: relId,
        auditState: auditState
      };
      const res=await this.$store.dispatch("auditGuiderInfo", params);
      if(res.code==="0") {
        this.queryList();
        this.$store.dispatch("auditRelStateCount");
      }
    },
    switchTab() {},
    getChecked() {},
    async audit(row) {
      const result = await this.$confirm(`是否同意？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        this.auditGuiderInfos(row.relId, "agree");
      }
    },
    submitRuleForm() {},
    handleCurrentChange() {},
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    load() {},
    toDetails(v) {
      this.$router.push({ name: "GuiderApplyDetails" });
    }
  }
};
</script>
<style lang="scss">
.sales-volumn-dialog {
  width: 800px;
}
@media screen and (max-width: 600px) {
  .sales-volumn-dialog {
    width: 320px;
  }
}
.reject-reason {
  .el-radio__label {
    white-space: normal;
    line-height: 24px;
  }
}
</style>
<style lang="scss" scoped>
.income {
  color: #e50065;
}
.title {
  width: 85px;
  text-align: right;
}

@media screen and (max-width: 414px) {
  .guider-apply-container {
    .pc {
      display: none;
    }
    .mobile {
      display: block;
      margin: -10px;
      font-size: 14px;
      .list {
        background: #fff;
        .price {
          font-size: 16px;
        }
        .list-item {
          padding: 15px 15px 15px 0;
          margin-left: 15px;
          border-bottom: 1px solid #efefef;
          color: #999;
          line-height: 25px;
        }
        .count {
          color: #589dff;
        }
        .price {
          color: #f72b2b;
        }
        .tag {
          background: linear-gradient(
            -86deg,
            rgba(247, 173, 74, 1),
            rgba(255, 128, 128, 1)
          );
          color: #fff;
          font-size: 10px;
          border-radius: 30px;
          padding: 0 5px;
          margin-right: 5px;
        }
        .user-info {
          margin-right: 5px;
          color: #2b2b2b;
        }
      }
      .merchant {
        color: #005ceb;
      }
      .tabs {
        background: #fff;
        padding: 15px;
        margin-bottom: 10px;
        .tab {
          position: relative;
          &.active:after {
            content: "";
            position: absolute;
            bottom: -17px;
            left: 50%;
            width: 50%;
            transform: translateX(-50%);
            border-bottom: 4px solid #005ceb;
            border-radius: 30px;
          }
        }
      }

      .scroll-content {
        padding-bottom: 20px;
      }

      .control-panel {
        background: #fff;
        padding: 15px;
        border-bottom: 1px solid #f5f5f5;
        .ipt-wrapper {
          background: #f0f0f0;
          height: 34px;
          line-height: 34px;
          border-radius: 30px;
          border-bottom: 1px solid #f5f5f5;
          margin-right: 5px;
          padding-left: 10px;
          input {
            height: 34px;
            border: none;
            background: transparent;
            padding-left: 5px;
            font-size: 14px;
            &:focus {
              outline: none;
            }
          }
        }
      }

      .info {
        margin-top: 10px;
        line-height: 25px;
      }
    }
  }
}
// @media screen and (min-width: 415px) {
//   .guider-apply-container {
//     .pc {
//       display: block;
//     }

//     .mobile {
//       display: none;
//     }
//   }
// }
</style>
